import { toTime } from "./time";

const HEISEI_START_DAY = new Date(1989, 1, 8, 0, 0, 0);

/**
 * 日付、日時を平成表記で取得する
 * 令和になっても平成N年N月と表示する
 * @param {Date} d
 * @returns {string}
 */
export function toHeisei(d = new Date) {
  const date = new Date(d.getTime());
  return `${toHeiseiDate(date)}${toTime(date)}`;
}

/**
 * 日付を平成表記で取得する
 * 令和になっても平成N年N月と表示する
 * @param {Date} d
 * @returns {string}
 */
export function toHeiseiDate(d = new Date) {
  const heisei = new Date(d.getTime());
  heisei.setFullYear(d.getFullYear() - HEISEI_START_DAY.getFullYear() + 1);

  const year = heisei.getFullYear();
  const month = heisei.getMonth() + 1;
  const date = heisei.getDate();

  return `平成${year}年${month}月${date}日`;
}

/**
 * 平成最初の日と引数の日で何日差があるか取得する
 * @param {Date} d
 * @returns {number}
 */
export function diffOfDays(d = new Date) {
  const diff = d.getTime() - HEISEI_START_DAY.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}
